import Box from "@mui/material/Box"
import Button from "@mui/material/Button"
import Container from "@mui/material/Container"
import Divider from "@mui/material/Divider"
import IconButton from "@mui/material/IconButton"
import InputLabel from "@mui/material/InputLabel"
import Stack from "@mui/material/Stack"
import TextField from "@mui/material/TextField"
import Typography from "@mui/material/Typography"
import WhatsAppIcon from "@mui/icons-material/WhatsApp"
import SitemarkIcon from "@/features/landing/template/components/SitemarkIcon"
import { FOOTER, BRAND } from "@/features/landing/content"
import { Link } from "react-router-dom"

function Copyright() {
  return (
    <Typography variant="body2" sx={{ color: "text.secondary", mt: 1 }}>
      {FOOTER.copyright}
    </Typography>
  )
}

export default function Footer() {
  return (
    <Container
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: { xs: 4, sm: 8 },
        py: { xs: 8, sm: 10 },
        textAlign: { sm: "center", md: "left" }
      }}>
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          width: "100%",
          justifyContent: "space-between"
        }}>
        {/* Brand + newsletter */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 4,
            minWidth: { xs: "100%", sm: "60%" }
          }}>
          <Box sx={{ width: { xs: "100%", sm: "60%" }, display: "none" }}>
            <SitemarkIcon />
            <Typography variant="body2" gutterBottom sx={{ fontWeight: 600, mt: 2 }}>
              {FOOTER.newsletterHeading}
            </Typography>
            <Typography variant="body2" sx={{ color: "text.secondary", mb: 2 }}>
              {FOOTER.newsletterBody}
            </Typography>
            <InputLabel htmlFor="footer-email-newsletter">Email</InputLabel>
            <Stack direction="row" spacing={1} useFlexGap>
              <TextField
                id="footer-email-newsletter"
                hiddenLabel
                size="small"
                variant="outlined"
                fullWidth
                aria-label="Enter your email address"
                placeholder={FOOTER.emailPlaceholder}
                slotProps={{
                  htmlInput: {
                    autoComplete: "off",
                    "aria-label": "Enter your email address"
                  }
                }}
                sx={{ width: "250px" }}
              />
              <Button variant="contained" color="primary" size="small" sx={{ flexShrink: 0 }}>
                {FOOTER.subscribeLabel}
              </Button>
            </Stack>
          </Box>
        </Box>

        {/* Product links */}
        <Box
          sx={{
            display: { xs: "none", sm: "flex" },
            flexDirection: "column",
            gap: 1
          }}>
          <Typography variant="body2" sx={{ fontWeight: "medium" }}>
            {FOOTER.columns.product.heading}
          </Typography>
          {FOOTER.columns.product.links.map(link => (
            <Link key={link.label} to={link.href}>
              {link.label}
            </Link>
          ))}
        </Box>

        {/* Legal links */}
        <Box
          sx={{
            display: { xs: "none", sm: "flex" },
            flexDirection: "column",
            gap: 1
          }}>
          <Typography variant="body2" sx={{ fontWeight: "medium" }}>
            {FOOTER.columns.legal.heading}
          </Typography>
          {FOOTER.columns.legal.links.map(link => (
            <Link key={link.label} to={link.href} style={{ color: "text.secondary" }}>
              {link.label}
            </Link>
          ))}
        </Box>
      </Box>

      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          pt: { xs: 4, sm: 8 },
          width: "100%",
          borderTop: "1px solid",
          borderColor: "divider"
        }}>
        <div>
          {FOOTER.bottomLinks.map((link, idx) => (
            <span key={link.label}>
              {idx > 0 && <Typography sx={{ display: "inline", mx: 0.5, opacity: 0.5 }}>&nbsp;•&nbsp;</Typography>}
              <Link to={link.href}>{link.label}</Link>
            </span>
          ))}
          <Copyright />
        </div>
        <Stack direction="row" spacing={1} useFlexGap sx={{ justifyContent: "left", color: "text.secondary" }}>
          <IconButton
            color="inherit"
            size="small"
            href={BRAND.whatsappChannelUrl}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="WhatsApp">
            <WhatsAppIcon />
          </IconButton>
        </Stack>
      </Box>

      <Divider sx={{ width: "100%" }} />
    </Container>
  )
}
